import { useNavigate } from "react-router-dom";

export type SmsTab = "balance" | "templates" | "auto" | "logs" | "reports" | "detalization";

interface SmsNavigationProps {
	activeTab: SmsTab;
}

export function SmsNavigation({ activeTab }: SmsNavigationProps) {
	const navigate = useNavigate();

	const tabStyle = (active: boolean) => ({
		background: active ? "var(--crm-primary, #2563eb)" : "#f1f5f9",
		color: active ? "#ffffff" : "#475569",
		border: "none",
		borderRadius: "8px",
		padding: "8px 16px",
		fontWeight: 600,
		cursor: "pointer",
		transition: "all 0.2s ease",
	});

	return (
		<div style={{ display: "flex", gap: "10px", marginBottom: "24px", flexWrap: "wrap" }}>
			<button
				type="button"
				style={tabStyle(activeTab === "balance")}
				onClick={() => navigate("/sms/balance")}
			>
				Balans va to'lovlar
			</button>
			<button
				type="button"
				style={tabStyle(activeTab === "templates")}
				onClick={() => navigate("/sms/templates")}
			>
				SMS shablonlari
			</button>
			<button
				type="button"
				style={tabStyle(activeTab === "auto")}
				onClick={() => navigate("/sms/auto")}
			>
				Avto-eslatma
			</button>
			<button
				type="button"
				style={tabStyle(activeTab === "logs")}
				onClick={() => navigate("/sms/logs")}
			>
				SMS loglar (Tarix)
			</button>
			<button
				type="button"
				style={tabStyle(activeTab === "reports")}
				onClick={() => navigate("/sms/reports")}
			>
				Hisobotlar
			</button>
			<button
				type="button"
				style={tabStyle(activeTab === "detalization")}
				onClick={() => navigate("/sms/detalization")}
			>
				Detalizatsiya
			</button>
		</div>
	);
}
